import React from "react";
import Image from "components/image";
import WishlistModalTriggerButton from "components/wishlist/modal-trigger-button";
import ProductLabel from "components/product/label";
import clsx from "clsx/lite";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "components/swiper";
import { Pagination, Mousewheel, Navigation } from "swiper/modules";
import { SCREEN_SIZES } from "utils/constants";
import { ReactComponent as Arrow } from "svgs/middle-size-arrow.svg";

const ImageWithOverlay = ({ baseImage, overlayImage, fallbackImg, title }) => (
	<>
		{baseImage ? <Image className={clsx(overlayImage ? "img-transition" : "img-transition-scale")} image={baseImage} />
			: fallbackImg && <img src={fallbackImg} alt={title} className={"img-transition-scale"} loading="lazy" />}
		{overlayImage &&
			<Image className="hidden md:flex !absolute top-0 right-0 bottom-0 left-0 opacity-0 img-transition-scale"
				image={overlayImage} />}
	</>
);
const CarouselLayout = ({ mobileimages = [], desktopImages = [], label, onSale, product }) => {
	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.sm });
	const leftArrowClass = `swiper-arrow-left-${product.id}`;
	const rightArrowClass = `swiper-arrow-right-${product.id}`;
	const images = isMobile ? mobileimages : desktopImages;

	const swiperSettings = {
		modules: [Pagination, Mousewheel, Navigation],
		pagination: { clickable: true },
		mousewheel: { enabled: true, forceToAxis: true },
		navigation: !isMobile ? {
			nextEl: `.${rightArrowClass}`,
			prevEl: `.${leftArrowClass}`,
			disabledClass: "!opacity-0",
		} : false,
		spaceBetween: 10,
		slidesPerView: 1,
		className: "relative",
	};

	return (
		<div className="images-v3-t-carousel !p-0 relative group">
			<Swiper {...swiperSettings}>
				{images?.map((img, idx) => (
					<SwiperSlide key={idx} className="relative">
						<Image image={img} className="w-full h-auto" />
					</SwiperSlide>
				))}
			</Swiper>
			{images?.length > 1 && !isMobile && (
				<>
					<button
						onClick={(e) => e.stopPropagation()}
						className={clsx( leftArrowClass, "left-3 carousel-arrow")} >
						<Arrow className="rotate-180" />
					</button>

					<button
						onClick={(e) => e.stopPropagation()}
						className={clsx( rightArrowClass, "right-3 carousel-arrow" )} >
						<Arrow />
					</button>
				</>
			)}
			<ProductLabel data={label || {}} onSale={onSale} />
  
			<div className="transition-all duration-300 absolute top-0 right-0 p-0 !z-[5]">
		  <div className="flex flex-col gap-4">
		  			<WishlistModalTriggerButton
						product={product}						
						className="p-2 sm:p-3.5 rounded-full flex md:size-fit"
						iconClassName="fill-white size-4"
					/>
		  </div>
			</div>
	  </div>
	);
};


const ProductImages = ({ product, openModal, showViewDetails = true, showModal = false, carouselLayout }) => {
	const { title, previewImageUrl: fallbackImg, label, variant, previewImages = [], desktopPreviewImages, mobilePreviewImages } = product;
	const [mainImage, hoverImage] = previewImages || [];
	const [mainImageDesktop, hoverImageDesktop, thirdImageDesktop] = desktopPreviewImages || [];

	const onSale = variant?.compareAtPrice && variant?.compareAtPrice > variant?.price;
	return (
		<div className="w-full relative overflow-hidden">
			<div className={clsx(carouselLayout && "images-v1-t-carousel", "images-v2-t67")}>
				<ImageWithOverlay baseImage={mainImage} overlayImage={hoverImage} fallbackImg={fallbackImg}  title={title}/>
			</div>
			<div className="images-t67 hidden">
				<ImageWithOverlay baseImage={mainImageDesktop} overlayImage={thirdImageDesktop || hoverImageDesktop} 
					fallbackImg={fallbackImg} title={title}/>
			</div>
			{carouselLayout && (
				<CarouselLayout
					mobileimages={mobilePreviewImages}
					desktopImages={desktopPreviewImages}
					label={label}
					onSale={onSale}
					product={product}						

				/>
			)}

			{showViewDetails && (
				<>
					<ProductLabel data={label || {}} onSale={onSale} />
					<div className={clsx(carouselLayout && "disable-transform-t65",
						"opacity-100 md:opacity-0 md:group-hover/card:opacity-100",
						"transition-all duration-300 absolute top-0 right-0 p-4")}>
						<div className="flex flex-col gap-4">
							<WishlistModalTriggerButton
								product={product}
								className="p-2 sm:p-3.5 bg-black rounded-full flex md:size-fit"
								iconClassName="fill-white size-4" />
						</div>
					</div>
					{showModal ?
						<button
							onClick={openModal}
							onKeyDown={(e) => e.key === "Enter" && openModal(e)}
							className="hidden md:block absolute bottom-0 w-full">
							<div className={clsx(carouselLayout && "disable-transform-t65",
								"bg-beige py-2.5 w-full text-center uppercase transform translate-y-full t67-shorter-modal",
								"transition-all duration-300 group-hover/card:translate-y-0")}>
								Quick view
							</div>
						</button>
						:
						<div className="hidden md:block absolute bottom-0 w-full">
							<div className={clsx(carouselLayout && "disable-transform-t65",
								"bg-beige py-2.5 w-full text-center uppercase transform translate-y-full ",
								"transition-all duration-300 group-hover/card:translate-y-0")}>
								View details
							</div>
						</div>
					}
				</>
			)}
		</div >
	);
};

export default ProductImages;